export default "__VITE_ASSET__be5afba4__"